import FlatList from "@components/FlatList";
import { PageProps } from "gatsby";
import React, { ReactElement } from "react";
import ResourceList from "./ResourceList";
import { PaginationProps } from "./Pagination";

const ProductContentFlatList = ({
  listDisplayType = "image",
  sectionTitle = "",
  content = [],
  videos = [],
  ifEmpty,
  pagination,
  location,
  showIcon = false,
  showPagination = false,
  itemSize = 325,
  autoFill = false,
}: {
  listDisplayType?: string;
  sectionTitle?: string;
  content?: Array<Queries.ProductContentFragment | null> | null;
  videos?: Array<Queries.VideoFragment | null> | null;
  ifEmpty?: ReactElement | null;
  pagination?: PaginationProps;
  location?: PageProps["location"];
  showIcon?: boolean;
  showPagination?: boolean;
  itemSize?: number;
  autoFill?: boolean;
}) => {
  const resources = [
    ...(videos?.flatMap((node) =>
      node
        ? {
            id: node.id,
            title: node.translations?.[0]?.title,
            slug: `/videos/${node.slug}`,
            description: node?.translations?.[0]?.description,
            image: node.vimeoVideoThumbnail ? node.vimeoVideoThumbnail?.childImageSharp?.gatsbyImageData : node.featuredImage?.childImageSharp?.gatsbyImageData,
            // imageUrl: node.featuredImage?.childImageSharp?.gatsbyImageData.images.fallback?.src,
            itemFileType: "video", // For FlatList
            type: "video", // For ResourceList
            sort: 1000,
          }
        : [],
    ) ?? []),
    ...(content?.flatMap((node) =>
      node?.id && node?.content_type?.slug_base
        ? {
            id: node.id,
            title: node.title,
            description: node.description,
            image: node.featuredImage?.childImageSharp?.gatsbyImageData,
            // imageUrl: node.featuredImage?.childImageSharp?.gatsbyImageData.images.fallback?.src,
            slug: node.externalLink ? node.externalLink : `/resources/${node.slug}`,
            itemFileType: node.content_type.slug_base, // For FlatList
            type: node.content_type.slug_base, // For ResourceList
            sort: node.sort ?? 100000,
          }
        : [],
    ) ?? []),
  ].sort((n1, n2) => n1.sort - n2.sort);

  return listDisplayType === "image" || listDisplayType === "feature" ? (
    <FlatList
      title={sectionTitle}
      items={resources}
      autoFill={autoFill}
      itemSize={itemSize}
      pagination={pagination}
      showIcon={showIcon}
      showPagination={showPagination}
      location={location}
    />
  ) : (
    <ResourceList items={resources} ifEmpty={ifEmpty} />
  );
};

export default ProductContentFlatList;
